import React, { useEffect, useRef, FC } from 'react';
import cls from 'classnames';

import { useClickOutside } from 'src/explore/hooks/useClickOutside';

import { IWebLink } from '../../../../../../types';
import LinksComponent from '../../../../../../molecules/Links';
import Close from './atoms/Close';

import styles from './index.module.sass';

interface LinksProps {
  data?: IWebLink[];
  open: boolean;
  onClose: () => void;
}

const Links: FC<LinksProps> = ({ data, open, onClose }) => {
  const ref = useRef( null );
  useClickOutside( ref.current, onClose );

  useEffect(() => {
    if ( open ) {
      document.body.classList.add( 'lock-to-md' );
    } else {
      document.body.classList.remove( 'lock-to-md' );
    }

    return () => document.body.classList.remove( 'lock-to-md' );
  }, [ open ]);

  return (
    <div
      className={cls( styles.overlay, {
        [styles.open]: open,
      })}
    >
      <div
        className={cls( styles.container, {
          [styles.open]: open,
        })}
        ref={ref}
      >
        <div
          className={cls( styles.reveal, {
            [styles.open]: open,
          })}
        >
          <Close onClick={onClose} />

          <LinksComponent
            className={{
              container: styles.links,
              item: styles.item,
              link: styles.link,
            }}
            data={data}
          />
        </div>
      </div>
    </div>
  );
};

export default Links;
